module.exports = __webpack_public_path__ + "img/SER-i-2-II.a8a8fba2.png";